import { render, staticRenderFns } from "./AlertDiamondIcon.vue?vue&type=template&id=1d1c52a9&scoped=true&"
import script from "./AlertDiamondIcon.vue?vue&type=script&lang=js&"
export * from "./AlertDiamondIcon.vue?vue&type=script&lang=js&"
import style0 from "./AlertDiamondIcon.vue?vue&type=style&index=0&id=1d1c52a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c52a9",
  null
  
)

export default component.exports